import firebase from 'firebase/app'

export interface ChatLog {
  id: string;
  from: string;
  text: string;
  timestamp: Date;
}

export class Chat {
  public logs: ChatLog[] = [];
  private gameChatCollection: firebase.firestore.CollectionReference;
  private query: firebase.firestore.Query;

  constructor (roomId: string, gameId: string) {
    this.gameChatCollection = firebase.firestore().collection(`room/${roomId}/game/${gameId}/chat`)
    this.query = this.gameChatCollection.orderBy('timestamp', 'asc')
    this.query.onSnapshot((snapshot) => {
      snapshot.docChanges().forEach((change) => {
        if (change.type === 'added') {
          const message = change.doc.data()
          this.logs.push({
            id: change.doc.id,
            from: message.from,
            text: message.text,
            timestamp: message.timestamp
          })
        }
      })
    })
  }

  public saveMessage (from: string, messageText: string) {
    return this.gameChatCollection.add({
      from,
      text: messageText,
      timestamp: firebase.firestore.FieldValue.serverTimestamp()
    }).catch((error) => {
      throw error
    })
  }
}
